export const franchiseArray = (departId, independ=true) => {
    if(!independ && !departId) {
        return [];
    }

    let org = window.vm.$store.state.basedata.baseDataRecords.Organization || [];

    org = (org[0] || {})[departId] || [];

    return org;
};

export const teamArray = (departId, medicalField, independ=true) => {
    if(!independ && (!departId || !medicalField) ) {
        return [];
    }

    if(departId) {
        let org = window.vm.$store.state.basedata.baseDataRecords.Organization || [];

        org = (org[0] || {})[departId] || [];

        org = org.filter(o => !medicalField || o.id == medicalField);

        let teams = [];
        org.forEach(o => {
            teams = teams.concat(o.teams);
        });

        return teams;
    }
    else if(medicalField) {
        let org = window.vm.$store.state.basedata.baseDataRecords.Organization || [];

        org = (org[0] || {});

        let temp = [];
        for(departId in org) {
            if(departId) {
                temp = temp.concat(org[departId]);
            }
        }
        org = temp;

        org = org.filter(o => !medicalField || o.id == medicalField);

        let teams = [];
        org.forEach(o => {
            teams = teams.concat(o.teams);
        });

        return teams;
    }
    else {
        return window.vm.$store.state.basedata.baseDataRecords.Teams;
    }
};

export const teamArrayByArray = (departId, medicalFieldArr, independ=true) => {
    if(!independ && (!departId || !medicalFieldArr || !medicalFieldArr.some(m => !!m)) ) {
        return [];
    }

    if(departId || (medicalFieldArr && medicalFieldArr.some(m => !!m))) {
        let org = window.vm.$store.state.basedata.baseDataRecords.Organization || [];

        org = (org[0] || {});

        let temp = [];
        for(departId in org) {
            if(departId) {
                temp = temp.concat(org[departId]);
            }
        }
        org = temp;

        org = org.filter(o => !medicalFieldArr || !medicalFieldArr.some(m => !!m) || medicalFieldArr.some(m => m == o.id));

        let teams = [];
        org.forEach(o => {
            teams = teams.concat(o.teams);
        });

        return teams;
    }
    else if(medicalFieldArr.some(m => !!m)) {
        let org = window.vm.$store.state.basedata.baseDataRecords.Organization || [];

        org = (org[0] || [])[departId] || [];

        org = org.filter(o => !medicalFieldArr || !medicalFieldArr.some(m => !!m) || medicalFieldArr.some(m => m == o.id));

        let teams = [];
        org.forEach(o => {
            teams = teams.concat(o.teams);
        });

        return teams;
    }
    else {
        return window.vm.$store.state.basedata.baseDataRecords.Teams;
    }
};
  


// WEBPACK FOOTER //
// ./src/util/organizationUtil.js